import { PAGE_URLS } from 'utils/constants';
import {
  getDepartmentNamesArray,
  getItemOrDefaultToValue,
} from '../../details';
import {
  getRiskConsequence,
  getRiskLevelValue,
  getRiskLikelihood,
} from '../../helper/zone';

export const transform = (list, globalDepartmentList = []) => {
  return list.map(data => {
    return {
      pageName: PAGE_URLS.ZONES.link,
      id: getItemOrDefaultToValue(data, 'id', '-'),
      zoneId: getItemOrDefaultToValue(data, 'zoneId', '-'),
      regionName: getItemOrDefaultToValue(data, 'regionName', '-'),
      securityCompany: getItemOrDefaultToValue(
        data,
        'securityCompanyName',
        '-',
      ),
      departments: getDepartmentNamesArray(globalDepartmentList, data),
      zone: getItemOrDefaultToValue(data, 'name', '-'),
      riskLevel: getRiskLevelValue(data.currentRisk),
      likelihood: getRiskLikelihood(data.currentRisk),
      consequence: getRiskConsequence(data.currentRisk),
      hazard: getItemOrDefaultToValue(data.currentRisk, 'context', '-'),
      boundary: data.boundary
        ? getItemOrDefaultToValue(data.boundary, 'points', []).map(bound => ({
            lat: bound.latitude,
            lng: bound.longitude,
          }))
        : [],
      centreOfGravity: getItemOrDefaultToValue(
        data.boundary,
        'centreOfGravity',
        null,
      ),
    };
  });
};
